<template>
  <iframe
    :src="`https://api.m60.com.br/v1/chatproxy?code=${code}`"
    class="w-100 py-0 chat-bot"
    frameborder="0"
  ></iframe>
</template>

<script>
export default {
  props: {
    code: {
      type: String,
      required: true
    }
  }
};
</script>

<style>
iframe {
  border-radius: 12px;
}
</style>
